<div class="row">
    <div class="col-lg-7">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [addText]="'Add New'"
                        [customAddText]="'Select'"
                        [customActionComponent]="this"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    @if (!isHeadline()) {
                        <button class="btn btn-success btn-sm ml-2" (click)="addToDoForOpportunity()" title="Convert this opportunity into a To-Do">
                            <i class="fas fa-plus"></i> Add To-Do
                        </button>
                        @if (canRankItems) {
                            @if (!isRankingMode) {
                                <button class="btn btn-primary btn-sm ml-2" (click)="toggleRankingMode()" title="Rank opportunities">
                                    <i class="fas fa-sort-numeric-up"></i> Rank Items
                                </button>
                            } @else {
                                <button
                                    class="btn btn-success btn-sm ml-2"
                                    (click)="applyRanks()"
                                    [disabled]="selectedForRanking.length !== maxRankingSelection"
                                    title="Apply ranks to selected opportunities"
                                >
                                    <i class="fas fa-check"></i> Apply Ranks ({{ selectedForRanking.length }}/{{ maxRankingSelection }})
                                </button>
                                <button class="btn btn-secondary btn-sm ml-2" (click)="cancelRanking()" title="Cancel ranking">
                                    <i class="fas fa-times"></i> Cancel
                                </button>
                            }
                        }
                    }
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    [minHeight]="70"
                    (initialized)="grid.initialize(mainGrid)"
                    [itemFormatter]="gridItemFormatter"
                    (destroy)="grid.destroy()"
                    (beginningEdit)="beginningEdit()"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    @if (isRankingMode && !isHeadline()) {
                        <wj-flex-grid-column [header]="'Select'" [width]="80" [align]="'center'">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                @if (!cell.item.doneDate) {
                                    <input
                                        type="checkbox"
                                        [checked]="isSelectedForRanking(cell.item)"
                                        [disabled]="!isSelectedForRanking(cell.item) && selectedForRanking.length >= maxRankingSelection"
                                        (click)="$event.stopPropagation()"
                                        (change)="toggleRankingSelection(cell.item)"
                                        title="Select for ranking"
                                    />
                                }
                            </ng-template>
                        </wj-flex-grid-column>
                    }
                    @if (!isHeadline()) {
                        <wj-flex-grid-column [header]="'Solved?'" [width]="110" [align]="'center'">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                @if (!cell.item.doneDate) {
                                    <button
                                        style="display: block; margin: 0 auto"
                                        class="btn btn-info btn-sm"
                                        (click)="solveOpportunity(cell.item)"
                                        title="Mark as solved"
                                    >
                                        Mark Solved
                                    </button>
                                } @else {
                                    <button
                                        style="display: block; margin: 0 auto"
                                        class="btn btn-success btn-sm"
                                        (click)="solveOpportunity(cell.item)"
                                        title="Mark as unsolved"
                                    >
                                        Solved!
                                    </button>
                                }
                            </ng-template>
                        </wj-flex-grid-column>
                    }
                    <wj-flex-grid-column [header]="'Rank'" [binding]="'rank'" [width]="75" [visible]="!isHeadline()"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Who'" [binding]="'userId'" [dataMap]="allUserMap" [width]="75"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Meeting'"
                        [binding]="'meetingNames'"
                        [width]="180"
                        [visible]="isLeadershipMeeting && isHeadline()"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="isHeadline() ? 'Headline' : 'Opportunity'"
                        [binding]="'name'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Expire Date'"
                        [binding]="'expirationDate'"
                        [width]="135"
                        [visible]="isHeadline()"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>

    <div class="col-lg-5" appAutoSize [minHeight]="100">
        @if (grid.selectedItem && !isInitialLoading) {
            <div class="h-100 d-flex flex-column">
                <h5 class="text-truncate text-muted" style="margin-bottom: 15px">Details for "{{ grid.selectedItem?.name }}"</h5>
                <div class="flex-grow-1" style="min-height: 0">
                    <quill-view
                        style="display: block; height: 100%"
                        [content]="grid.selectedItem?.details ?? 'No Details'"
                        theme="snow"
                    ></quill-view>
                </div>
            </div>
        } @else {
            <div
                class="d-flex align-items-center justify-content-center h-100"
                [style.visibility]="isInitialLoading ? 'hidden' : 'visible'"
            >
                <div class="text-center">
                    <div class="mb-3">
                        <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                    </div>
                    <h5 class="text-muted mb-2">No {{ isHeadline() ? 'Headline' : 'Opportunity' }} Selected</h5>
                    <p class="text-muted mb-0">
                        Select a {{ isHeadline() ? 'headline' : 'opportunity' }} from the list to view its details
                    </p>
                </div>
            </div>
        }
    </div>
</div>
